// imports section
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  Breadcrumbs,
  Autocomplete,
  Link,
  AppBar,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { Slide } from "@mui/material";
import { externalgetApi, externalpostApi } from "../../services/external/externalApis";
import { SETTINGS_API_25, CHAINCODE, MENUTYPECODE } from "../../api/ApiModel";
import { useSelector } from "react-redux";

import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_YES,
  CON_STATUS_YES,
  CON_STATUS_NO,
} from "../../utils/sys/Constants";

const OrderTracking = () => {
  // Hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [error1, setError1] = useState(null);
    const [dataitem, setDataitem] = useState([]);
  const isEdit = location.state?.actionText === "Edit";
  const options = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ];
  const queryOptions = ["Yes", "No"];
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    ORDERSTSCODE: "",
    ORDERSTATUS: "",
    SEQ: "",
    SENDSMS: "",
    ENUSER: "",
  });
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [data, setData] = useState(null);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    console.log("Selected Item:", selectedItem);
    if (selectedItem) {
      setSelectedItemDetails({
        ORDERSTATUS: String(selectedItem.ORDERSTATUS),
        SENDSMS:
          selectedItem.SMSTEXT === CON_YES ? CON_STATUS_YES : CON_STATUS_NO,
        SEQ: selectedItem.SEQ,
        ORDERSTSCODE: String(selectedItem.ORDERSTSCODE),
        ENUSER: selectedItem.ENUSER,
      });
    }
  }, [selectedItem]);

   useEffect(() => {
      fetchData();
    }, []);

  // Handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedItemDetails({
      ...selectedItemDetails,

      [name]: value,
    });
setOpenErrorSnackbar(false); // Reset the snackbar state on input change
    validateField(name, value);
    
  };

   const fetchData = async () => {
        try {
          const result = await externalgetApi(SETTINGS_API_25, "get", {
            COMPCODE,
            LOCCODE,
            RESTCODE,
            STS: CON_STATUS_ACTIVE,
          });
          setDataitem(result);
        } catch (err) {
          console.error("Error fetching data:", err);
        }
      };

  const handleConfirmClick = async () => {
    const { SENDSMS, SEQ, ORDERSTATUS, ENUSER } = selectedItemDetails;

    const requiredFields = [
      { name: "ORDERSTATUS", value: ORDERSTATUS, label: "Order Tracking Type" },
      { name: "SEQ", value: SEQ, label: "Tracking Type Sequence" },
      { name: "SENDSMS", value: SENDSMS, label: "Send SMS" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }
    // Continue with the rest of your function logic...

    const orderstscode = selectedItem
      ? String(selectedItem.ORDERSTSCODE || "")
      : "";

    if (dataitem) {
      const isDuplicate = dataitem.some((item) => 
          item.ORDERSTSCODE != selectedItemDetails.ORDERSTSCODE &&
          item.ORDERSTATUS.toLowerCase().trim() === selectedItemDetails.ORDERSTATUS.toLowerCase().trim()
       );

      if (isDuplicate) {
        setSnackbarMessage("Tracking type already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      ENUSER: USERNAME,
      STS: CON_STATUS_ACTIVE,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      console.log(payload);
      const responseData = await externalpostApi(SETTINGS_API_25, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        ORDERSTSCODE: "",
        ORDERSTATUS: "",
        SEQ: "",
        SENDSMS: "",
        ENUSER: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }

    setTimeout(() => {
      navigate("/vOrderTracking");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      ORDERSTSCODE: "",
      ORDERSTATUS: "",
      SEQ: "",
      SENDSMS: "",
      ENUSER: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const gotToView = () => {
    navigate("/vOrderTracking");
  };

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError1("");
      handleInputChange(event);
    } else {
      setError1("Only numbers and floats are allowed.");
    }
  };

  const validateField = (name, value) => {
    const fieldErrors = { ...errors };

    // Check if the field is empty
    if (!value) {
      fieldErrors[name] = `${name} is required.`;
    } else {
      delete fieldErrors[name]; // Clear error if valid
    }

    setErrors(fieldErrors);
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover" href="/">
                  Home
                </Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">{isEdit ? "Edit Order Tracking" : "Create Order Tracking"}</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit ? "Edit Order Tracking" : "Create Order Tracking",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Order Tracking Type"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              value={selectedItemDetails.ORDERSTATUS}
              onChange={handleInputChange}
              name="ORDERSTATUS"
              error={Boolean(errors.ORDERSTATUS)}
              helperText={errors.ORDERSTATUS}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Tracking Type Sequence"
              size="small"
              fullWidth
              required
              variant="outlined"
              autoComplete="off"
              value={selectedItemDetails.SEQ}
              onChange={handlenumInputValidation}
              name="SEQ"
              error={Boolean(errors.SEQ)}
              helperText={errors.SEQ}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
          {/* <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl fullWidth size="small">
              <Autocomplete
                options={options}
                getOptionLabel={(option) => option.label}
                value={
                  options.find(
                    (option) => option.value === selectedItemDetails.SENDSMS
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "SENDSMS",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Send SMS<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    variant="outlined"
                    error={Boolean(errors.MENUTYPECODE)}
                    helperText={errors.MENUTYPECODE}
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </FormControl>
          </Grid> */}

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <FormControl fullWidth size="small">
              <Autocomplete
                options={options}
                getOptionLabel={(option) => option.label}
                value={
                  options.find(
                    (option) => option.value === selectedItemDetails.SENDSMS
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "SENDSMS",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Send SMS<span style={{ color: "red" }}> *</span>
                      </span>
                    }
                    size="small"
                    variant="outlined"
                    error={Boolean(errors.SENDSMS)}
                    helperText={errors.SENDSMS}
                    onBlur={(e) => validateField(e.target.name, e.target.value)} // Validation on blur
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          TransitionComponent={(props) => <Slide {...props} direction="left" />} // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default OrderTracking;
